var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleQuarterCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 211,
    viewBox: "0 0 106 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 52.9677C106 82.1762 82.2264 105.935 53 105.935C23.7735 105.935 0 82.1762 0 52.9677C0 23.759 23.7735 0 53 0C82.2264 0 106 23.759 106 52.9677Z",
    fill: "#007969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.152588 105.545H105.091V210.28L101.098 210.273C36.6822 210.112 2.77082 176.27 0.306191 109.675L0.152588 105.545Z",
    fill: "#F69E89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 210.317,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuarterCircle);
export default __webpack_public_path__ + "static/media/circle-quarterCircle.19d5262dc9c9ae367970823c16806d81.svg";
export { ForwardRef as ReactComponent };